module.exports = __webpack_public_path__ + "img/japanse-curry.1fc2612e.jpg";